import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import BulkEmailForm from '../../../components/forms/BulkEmailForm';
import {BulkEmailClient, BulkEmailDTO} from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const BulkEmailCreate: React.FC = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [initialValues, setInitialValues] = useState<BulkEmailDTO>({});
    const [attachmentFile, setAttachmentFile] = useState<File | null>(null);
    const navigate = useNavigate();
    const apiClient = new BulkEmailClient(API_BASE_URL, axiosInstance);

    const breadcrumbs = [
        { label: 'Admin', href: '#' },
        { label: 'Bulk Emails', href: '/admin/bulkemails' },
        { label: 'Create', href: '#' },
    ];

    const handleSubmit = async (data: BulkEmailDTO) => {
        setIsSubmitting(true);
        try {
            let updatedValues = { ...initialValues };

            // If there's an attachment file, upload it and add the attachmentPath to updatedValues
            if (attachmentFile) {
                const response = await apiClient.uploadBulkEmailAttachment(
                    attachmentFile.name,
                    attachmentFile
                );
                if (response && response.success && response.data) {
                    updatedValues = { ...updatedValues, attachmentPath: response.data };
                }
            }
            
            await apiClient.createBulkEmail(updatedValues);
            navigate('/admin/bulkemails');
        } catch (error) {
            console.error('Error creating bulk email:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <AdminLayout
            title="Create Bulk Email"
            breadcrumbs={breadcrumbs}
            allowedRoles={['Administrator']}
        >
            <Card>
                <BulkEmailForm
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    setAttachmentFile={setAttachmentFile}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate('/admin/bulkemails')}
                />
            </Card>
        </AdminLayout>
    );
};

export default BulkEmailCreate;
